<template>
  <button
    type="button"
    class="app-ib"
    :class="classes"
    :style="sizeStyle"
    :disabled="disabled"
    :aria-label="label"
    :aria-pressed="pressed ? 'true' : null"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <app-icon :name="icon" :size="iconSize" :style="iconStyle" />
    <v-tooltip
      v-if="tooltipOn"
      :activator="$el"
      :bottom="tipSide === 'bottom'"
      :top="tipSide === 'top'"
      :left="tipSide === 'left'"
      :right="tipSide === 'right'"
      open-delay="400"
      content-class="app-tooltip"
    >
      <span>{{ label }}</span>
    </v-tooltip>
  </button>
</template>

<script>
// Icon-Knopf (Spezifikation 2.6): quadratisch 32/44 (Rail 36), Icon 16/20 (Rail 18), weiche Kante --edge mit Schatten --sh-ctl.
// label ist Pflicht (aria-label und Tooltip; Tooltip nur bei Maus, unten, 400 ms Verzögerung).
// boxed=false (randlos) nur für: Schließen-× im Kopfstreifen, Pfeile in Verbünden, Icons in Feldern, Chevrons,
// Navigationspunkte. pressed (z. B. Menü offen) → --sel mit Kante --link; als v-menu-Aktivator mit
// v-bind="attrs" wird der offene Zustand (aria-expanded) automatisch als pressed gezeigt.
// Der Tooltip hängt über die activator-Prop am Knopf selbst: $el bleibt der Knopf (wichtig als v-menu-Aktivator),
// und die Tooltip-attrs (aria-haspopup) landen nicht am Knopf.
import AppIcon from './AppIcon.vue';

export default {
  name: 'AppIconButton',
  components: { AppIcon },
  inheritAttrs: false,
  props: {
    icon: { type: String, required: true },
    label: { type: String, required: true },
    size: { type: [String, Number], default: 'auto' },
    boxed: { type: Boolean, default: true },
    disabled: { type: Boolean, default: false },
    pressed: { type: Boolean, default: false },
    // Tooltip-Seite: 'bottom' (Standard), 'top', 'right', 'left'; false oder 'none' ohne Tooltip
    tooltip: { type: [String, Boolean], default: 'bottom' }
  },
  data() {
    return { mounted: false };
  },
  computed: {
    fixedSize() {
      const n = Number(this.size);
      return this.size !== 'auto' && n > 0 ? n : null;
    },
    menuOpen() {
      return this.$attrs['aria-expanded'] === 'true';
    },
    classes() {
      return {
        'app-ib--plain': !this.boxed,
        'app-ib--pressed': this.pressed || this.menuOpen
      };
    },
    sizeStyle() {
      return this.fixedSize ? { width: this.fixedSize + 'px', height: this.fixedSize + 'px' } : null;
    },
    iconSize() {
      const s = this.fixedSize;
      if (!s) {
        return 16;
      }
      return s >= 44 ? 20 : (s >= 36 ? 18 : 16);
    },
    iconStyle() {
      return this.fixedSize ? { width: this.iconSize + 'px', height: this.iconSize + 'px' } : null;
    },
    tipSide() {
      return ['top', 'right', 'left'].indexOf(this.tooltip) !== -1 ? this.tooltip : 'bottom';
    },
    tooltipOn() {
      const touch = !!(this.$dichte && this.$dichte.touch);
      return this.mounted && !touch && this.tooltip !== false && this.tooltip !== 'none' && !this.menuOpen;
    }
  },
  mounted() {
    this.mounted = true;
  },
  methods: {
    focus() {
      this.$el.focus();
    }
  }
};
</script>
